import React from 'react';
import { useTableHeightSync } from 'modules/benefitsWellness/components/TableContext/TableContextProvider';
import MissingInfo from 'modules/benefitsWellness/components/MissingInfo/MissingInfo';
import CustomField from 'model/CustomField';
import styles from './mdvCardCustomValue.module.less';

type Props = {
  title: any;
  data: CustomField;
  isMobile: boolean;
  isEditMode: boolean;
  dataIndex?: number;
};

const MDVCardCustomValue = (props: Props) => {
  const { data, isEditMode, isMobile, title, dataIndex } = props;
  const { height, ref } = useTableHeightSync(data?.fieldName, dataIndex);

  if (isEditMode && data?.fieldValue === title?.defaultValue) {
    return <MissingInfo missingInfoText="Missing Info" />;
  }

  return (
    <div>
      {isMobile && (
        <div className={styles.customFieldMobile}>{data?.fieldName}</div>
      )}
      <div
        ref={ref}
        style={!isMobile ? { height } : {}}
        className={`${styles.customFieldValueWrapper} ${
          isEditMode ? styles.textTruncated : ''
        }`}
        title={data?.fieldValue}
      >
        <span className={styles.textStyles}>
          {!isEditMode && data?.fieldValue === title?.defaultValue
            ? '-'
            : data?.fieldValue}
        </span>
      </div>
    </div>
  );
};

export default MDVCardCustomValue;
